import { render, staticRenderFns } from "./relationship-recognition-list.vue?vue&type=template&id=71c3dc63"
import script from "./relationship-recognition-list.vue?vue&type=script&lang=js"
export * from "./relationship-recognition-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c3dc63')) {
      api.createRecord('71c3dc63', component.options)
    } else {
      api.reload('71c3dc63', component.options)
    }
    module.hot.accept("./relationship-recognition-list.vue?vue&type=template&id=71c3dc63", function () {
      api.rerender('71c3dc63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/seedFarm-management/relationship-recognition/relationship-recognition-list.vue"
export default component.exports